import { getRepresentativeImageRedirectPath } from './getRepresentativeImageRedirectPath';

export const aiStudioService = {
  getRepresentativeImageRedirectPath,
};
